@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;

.errorNotification {
    background-color: $errorNotificationBackgroundColor;
    height: rem(46px);
}
